import jsLogo from '../logos/javascript-logo.webp';
import html5Logo from '../logos/html5-logo.png';
import css3Logo from '../logos/css3-logo.png';
import phpLogo from '../logos/php-logo.webp';
import pdoLogo from '../logos/pdo-logo.png';
import tailwindLogo from '../logos/tailwind-logo.avif';
import laravelLogo from '../logos/laravel-logo.png';
import sqliteLogo from '../logos/sqlite-logo.png';
import sassLogo from '../logos/sass-logo.png';
import symfonyLogo from '../logos/symfony-logo.webp';
import bulmaLogo from '../logos/bulma-logo.png';
import dartLogo from '../logos/dart-logo.png';
import doctrineLogo from '../logos/doctrine-logo.png';
import mongodbLogo from '../logos/mongodb-logo.ico';
import bootstrapLogo from '../logos/bootstrap-logo.png';
import flutterLogo from '../logos/flutter-logo.png';
import mysqlLogo from '../logos/mysql-logo.png';
import nodeLogo from '../logos/node-logo.webp';
import javaLogo from '../logos/java-logo.png';
import mdLogo from '../logos/md-logo.png';
import lessLogo from '../logos/less-logo.png';
import postgresqlLogo from '../logos/postgresql-logo.webp';
import pythonLogo from '../logos/python-logo.png';
import reactLogo from '../logos/react-logo.png';
import vueLogo from '../logos/vue-logo.png';
import wordpressLogo from '../logos/wordpress-logo.png';
import twigLogo from '../logos/twig-logo.png';
import expressLogo from '../logos/express-logo.png';
import daisyuiLogo from '../logos/daisyui-logo.png';
import firebaseLogo from '../logos/firebase-logo.webp';
import mariadbLogo from '../logos/mariadb-logo.webp';
import gutenbergLogo from '../logos/gutenberg-logo.webp';
import elementorLogo from '../logos/elementor-logo.webp';
import cakephpLogo from '../logos/cakephp-logo.webp';
import codeigniterLogo from '../logos/codeigniter-logo.webp';
import viteLogo from '../logos/vite-logo.webp';
import goLogo from '../logos/go-logo.webp';
import hugoLogo from '../logos/hugo-logo.webp';
import angularLogo from '../logos/angular-logo.webp';
import typescriptLogo from '../logos/typescript-logo.webp';
import ajaxLogo from '../logos/ajax-logo.webp';
import jqueryLogo from '../logos/jquery-logo.webp';
import rubyLogo from '../logos/ruby-logo.webp';
import rubyonrailsLogo from '../logos/rubyonrails-logo.webp';
import kotlinLogo from '../logos/kotlin-logo.webp';
import swiftLogo from '../logos/swift-logo.webp';
import csharpLogo from '../logos/csharp-logo.png';
import alpinejsLogo from '../logos/alpinejs-logo.webp';
import surrealdbLogo from '../logos/surrealdb-logo.webp';
import qwikLogo from '../logos/qwik-logo.webp';
import astroLogo from '../logos/astro-logo.webp';
import nextjsLogo from '../logos/nextjs-logo.webp';

const logos = {
  JavaScript: jsLogo,
  HTML5: html5Logo,
  CSS3: css3Logo,
  PHP: phpLogo,
  PDO: pdoLogo,
  TailwindCSS: tailwindLogo,
  Laravel: laravelLogo,
  SQLite: sqliteLogo,
  Sass: sassLogo,
  Symfony: symfonyLogo,
  Bulma: bulmaLogo,
  Dart: dartLogo,
  Doctrine: doctrineLogo,
  MongoDB: mongodbLogo,
  Bootstrap: bootstrapLogo,
  Flutter: flutterLogo,
  MySQL: mysqlLogo,
  NodeJS: nodeLogo,
  Java: javaLogo,
  Markdown: mdLogo,
  Less: lessLogo,
  PostgreSQL: postgresqlLogo,
  Python: pythonLogo,
  React: reactLogo,
  "React Native": reactLogo,
  Vue: vueLogo,
  Wordpress: wordpressLogo,
  Twig: twigLogo,
  Express: expressLogo,
  daisyUI: daisyuiLogo,
  Firebase: firebaseLogo,
  MariaDB: mariadbLogo,
  SCSS: sassLogo,
  Gutenberg: gutenbergLogo,
  Elementor: elementorLogo,
  CakePHP: cakephpLogo,
  CodeIgniter: codeigniterLogo,
  Vite: viteLogo,
  Golang: goLogo,
  Hugo: hugoLogo,
  Angular: angularLogo,
  TypeScript: typescriptLogo,
  AJAX: ajaxLogo,
  jQuery: jqueryLogo,
  Ruby: rubyLogo,
  "Ruby On Rails": rubyonrailsLogo,
  Kotlin: kotlinLogo,
  Swift: swiftLogo,
  "C#": csharpLogo,
  AlpineJS: alpinejsLogo,
  SurrealDB: surrealdbLogo,
  Qwik: qwikLogo,
  Astro: astroLogo,
  NextJS: nextjsLogo
};

export default logos;